import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import VueGtag from "vue-gtag";

// Custom plugins
import Images from './util/images.js'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faDiscord,
	faFacebook,
	faLinkedin,
	faReddit,
	faTwitter
} from '@fortawesome/free-brands-svg-icons'
import {
  faTrophy,
  faHashtag,
  faArrowUp,
  faArrowDown,
  faSortDown,
  faCaretUp,
  faCaretDown,
  faCheck,
  faUsers,
  faUser,
  faCog,
  faSignOutAlt,
  faTimes,
  faSortAlphaDown,
  faMoneyBillWave,
  faEye,
  faEyeSlash,
  faAward,
  faChartLine,
  faAngleRight,
  faStore,
  faTags,
  faTag,
  faSearch,
  faPlusCircle,
  faPlus,
  // faPlus/faMinus/faTimesCircle look unused — nothing in web/src names them.
  // They're for Buefy's own internals: the numberinput steppers and the
  // clearable/validation affordances on inputs. Dropping them leaves those
  // controls with empty icon slots and no error.
  faMinus,
  faLink,
  faHome,
  faArrowCircleRight,
  faArrowLeft,
  faArrowRight,
  faTimesCircle,
  faUserPlus,
  faPlay,
  faGamepad,
  faBookOpen,
  faLock,
  faEllipsisV,
  faPen,
  faSun,
  faLeaf,
  faSnowflake,
  faSeedling,
  // Stats page headline cards.
  faPercent,
  faStar,
  // Premium's mark, on the profile and the sales page.
  faCrown,
  // The reward track's claim mark on a phone, where the card is the tap
  // target and this stands in for the level number.
  faGift,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VueAnimateOnScroll from 'vue-animate-onscroll'

Vue.use(Buefy, {
  defaultIconComponent: 'vue-fontawesome',
  defaultIconPack: 'fas',
})

Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GA_ID }
}, router);

Vue.use(VueAnimateOnScroll)

Vue.use(Images)

library.add(
  // fab
  faDiscord,
  faTwitter,
	faFacebook,
	faReddit,
	faLinkedin,
  // fas
  faTrophy,
	faLink,
	faHashtag,
	faArrowUp,
	faArrowDown,
	faArrowLeft,
	faArrowRight,
	faSortDown,
	faCaretUp,
	faCaretDown,
  faCheck,
	faUsers,
	faUser,
	faCog,
	faSignOutAlt,
	faTimes,
	faSortAlphaDown,
	faMoneyBillWave,
  faEye,
	faEyeSlash,
	faAward,
	faChartLine,
	faAngleRight,
	faStore,
	faTags,
	faTag,
  faSearch,
	faPlusCircle,
	faPlus,
	faMinus,
	faHome,
	faArrowCircleRight,
	faTimesCircle,
	faUserPlus,
	faPlay,
	faGamepad,
	faBookOpen,
	faLock,
	faEllipsisV,
	faPen,
	faSun,
	faLeaf,
	faSnowflake,
	faSeedling,
	faPercent,
	faStar,
	faCrown,
	faGift
)

Vue.component('vue-fontawesome',
	FontAwesomeIcon);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  debug: true,
  render: function (h) { return h(App) }
}).$mount('#app')
